export function setCountries (state, paises) {
  state.paises = paises
}

export function setProvinces (state, provincias) {
  state.provinces = provincias
}
